import { useContext } from "react"
import { OkCancelContext } from "lib/@hooks/useDialog"

export function useOkCancelContext() {
    return useContext(OkCancelContext)
}
